/** Shared zoom limits for PDF / image file viewers. */

/** Manual zoom floor — low enough for large Retina screenshots on small laptops. */
export const VIEWER_ZOOM_MIN = 0.05;

export const VIEWER_ZOOM_MAX = 6;

/** Multiplicative step (~35% area change per click). */
export const VIEWER_ZOOM_STEP = 1.35;

export const VIEWER_FIT_PADDING_PX = 32;

export function clampViewerZoom(scale: number): number {
  return Math.max(VIEWER_ZOOM_MIN, Math.min(VIEWER_ZOOM_MAX, scale));
}

/**
 * Scale to fit content inside the available area. No minimum — fit-to-window
 * must be able to shrink below VIEWER_ZOOM_MIN for oversized uploads.
 */
export function computeViewerFitScale(
  availWidth: number,
  availHeight: number,
  contentWidth: number,
  contentHeight: number,
): number | null {
  if (availWidth <= 0 || availHeight <= 0 || contentWidth <= 0 || contentHeight <= 0) return null;
  const fit = Math.min(availWidth / contentWidth, availHeight / contentHeight);
  return Math.min(VIEWER_ZOOM_MAX, fit);
}
